import React from 'react';

const Footer = () => {

    return (
        <div style={{backgroundColor: '#5089C6'}} className='flex justify-center'>
            <p style={{fontSize: '1.5rem', padding: '0.5rem'}}>Created by Josh Gannon</p>
        </div>
    )
}

export default Footer;